import { render, staticRenderFns } from "./RecutRateTable.vue?vue&type=template&id=615ea336&scoped=true&"
import script from "./RecutRateTable.vue?vue&type=script&lang=js&"
export * from "./RecutRateTable.vue?vue&type=script&lang=js&"
import style0 from "./RecutRateTable.vue?vue&type=style&index=0&id=615ea336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ea336",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
